export interface TestCase {
  id: string;
  input: any;
  expectedOutput: any;
  description: string;
  isHidden?: boolean;
  tolerance?: number; // For floating-point comparisons
}

export interface ChallengeTestSuite {
  [challengeId: string]: TestCase[];
}

export const testCases: ChallengeTestSuite = {
  "sigmoid-function": [
    {
      id: "test-1",
      input: 0,
      expectedOutput: 0.5,
      description: "sigmoid(0) should equal 0.5",
      tolerance: 0.0001,
    },
    {
      id: "test-2",
      input: 1,
      expectedOutput: 0.7310585786300049,
      description: "sigmoid(1) should equal ~0.731",
      tolerance: 0.0001,
    },
    {
      id: "test-3",
      input: -1,
      expectedOutput: 0.2689414213699951,
      description: "sigmoid(-1) should equal ~0.269",
      tolerance: 0.0001,
    },
    {
      id: "test-4",
      input: [0, 1, 2],
      expectedOutput: [0.5, 0.7310585786300049, 0.8807970779778823],
      description: "sigmoid([0, 1, 2]) should work with arrays",
      tolerance: 0.0001,
      isHidden: true,
    },
  ],
  "cross-entropy-loss": [
    {
      id: "test-1",
      input: { y_pred: [0.9, 0.1, 0.8], y_true: [1, 0, 1] },
      expectedOutput: 0.191608,
      description: "Basic cross-entropy calculation",
      tolerance: 0.001,
    },
    {
      id: "test-2",
      input: { y_pred: [0.5, 0.5], y_true: [1, 0] },
      expectedOutput: 0.693147,
      description: "Perfect uncertainty case",
      tolerance: 0.001,
    },
  ],
  "mean-variance": [
    {
      id: "test-1",
      input: [1, 2, 3, 4, 5],
      expectedOutput: { mean: 3.0, variance: 2.0 },
      description: "Calculate mean and variance for simple dataset",
      tolerance: 0.0001,
    },
    {
      id: "test-2",
      input: [10, 10, 10, 10],
      expectedOutput: { mean: 10.0, variance: 0.0 },
      description: "Variance should be 0 for uniform data",
      tolerance: 0.0001,
    },
    {
      id: "test-3",
      input: [2, 4, 4, 4, 5, 5, 7, 9],
      expectedOutput: { mean: 5.0, variance: 4.0 },
      description: "Calculate for more complex dataset",
      tolerance: 0.0001,
    },
  ],
  "decision-stump": [
    {
      id: "test-1",
      input: {
        X: [[1], [2], [3], [4]],
        y: [0, 0, 1, 1],
      },
      expectedOutput: { threshold: 2.5, feature: 0 },
      description: "Find optimal threshold",
    },
  ],
  "knn": [
    {
      id: "test-1",
      input: {
        X_train: [[1, 1], [2, 2], [3, 3]],
        y_train: [0, 0, 1],
        X_test: [[1.5, 1.5]],
        k: 2,
      },
      expectedOutput: [0],
      description: "KNN classification with k=2",
    },
  ],
  "logistic-regression": [
    {
      id: "test-1",
      input: {
        X: [[1, 2], [2, 3], [3, 4]],
        y: [0, 0, 1],
        iterations: 100,
      },
      expectedOutput: { converged: true },
      description: "Logistic regression should converge",
    },
  ],
};
